export default (placeholder, count) =>
  count > 1 ? `${placeholder} (${count})` : placeholder;
